export enum PaymentType {
    CARD = 0,
    PAYPAL = 1,
    GOOGLEPAY = 2,
    APPLEPAY = 3,
    PAYPALCHECKOUT = 4,
    ADDEDCARD = 5,
    NEWCARD = 6,
    GROUPTAB = 7,
    // MEMBERSHIP = 8,
    POS = 9,
}
